import { Box } from "@chakra-ui/react";
import { baseColors, BaseStack } from "goi_common/src/design-system";

interface FomoReassuranceInlineBannerProps {
  variant?: "fomo" | "quiz_coupon";
}

export function FomoReassuranceInlineBanner({
  variant = "fomo",
}: FomoReassuranceInlineBannerProps) {
  return (
    <Box
      width="calc(100% - 32px)"
      maxWidth="440px"
      mx="auto"
      background={baseColors.label_normal}
      borderRadius="12px"
      px="12px"
      py="10px"
    >
      <BaseStack spacing={4}>
        <Box
          className="body_1_normal_sb"
          color={baseColors.white}
          whiteSpace="nowrap"
        >
          {variant === "quiz_coupon" ? (
            <>
              🎁{" "}
              <span style={{ color: baseColors.red_300 }}>
                10만원 할인 쿠폰
              </span>
              이 적용됐어요
            </>
          ) : (
            <>
              <span style={{ color: baseColors.red_300 }}>
                10만원 추가 할인
              </span>
              이 적용됐어요
            </>
          )}
        </Box>
        <Box
          className="body_1_normal_sb"
          color={baseColors.white}
          whiteSpace="nowrap"
        >
          {variant === "quiz_coupon"
            ? "지금 가입 시 할인된 금액으로 이용하실 수 있어요"
            : "지금 가입을 완료하지 않으면 혜택이 사라져요"}
        </Box>
      </BaseStack>
    </Box>
  );
}
